import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { App } from "./App";
import { IpcProvider } from "./ipc/IpcProvider";
import { AuthGate } from "./features/auth/AuthGate";
import { useAppStore } from "./state/app-store";
import "./design-system/global.css";
import "./design-system/components.css";

// Aplica el tema inicial del store al documento.
useAppStore.getState().setTheme(useAppStore.getState().theme);

const container = document.getElementById("root");
if (!container) throw new Error("No se encontró el nodo #root");

createRoot(container).render(
  <StrictMode>
    <IpcProvider>
      {/* AuthGate: en la PWA exige login; en Electron/dev deja pasar. */}
      <AuthGate>
        {/* HashRouter: compatible con carga desde file:// en la app Electron empaquetada. */}
        <HashRouter>
          <App />
        </HashRouter>
      </AuthGate>
    </IpcProvider>
  </StrictMode>,
);

// Service worker para instalar como PWA (solo en producción, no en Electron file://).
if (import.meta.env.PROD && typeof navigator !== "undefined" && "serviceWorker" in navigator && location.protocol.startsWith("http")) {
  window.addEventListener("load", () => { void navigator.serviceWorker.register("/sw.js").catch(() => { /* sin SW no pasa nada grave */ }); });
}
